import { render } from "./card.component.vue?vue&type=template&id=058096a6"
import script from "./card.component.vue?vue&type=script&lang=js"
export * from "./card.component.vue?vue&type=script&lang=js"

import exportComponent from "/builds/ASIP-Sante/g1/shared/santefr/web/modules/custom/sante_vuejs/vue-core/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__file',"src/components/periple/cards/card.component.vue"]])
/* hot reload */
if (module.hot) {
  __exports__.__hmrId = "058096a6"
  const api = __VUE_HMR_RUNTIME__
  module.hot.accept()
  if (!api.createRecord('058096a6', __exports__)) {
    console.log('reload')
    api.reload('058096a6', __exports__)
  }
  
  module.hot.accept("./card.component.vue?vue&type=template&id=058096a6", () => {
    console.log('re-render')
    api.rerender('058096a6', render)
  })

}


export default __exports__